import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

export const HorizontalSeparator = styled('span', () => ({
  width: '100%',
  margin: '8px 0',
  height: '1px',
  background: lightTheme.colors.grayScale100,
}))